import { nullPromise } from 'prelude'
import React from 'react'

type Result<a,b> = [Promise<a>,(_:b) => Promise<a>]

export const useFetch = <a,b>(fetch:(_:b) => Promise<a>,input:b,dependencies:React.DependencyList) : Result<a,b> => {
  const [stateFetching,setFetching] = React.useState<Promise<a>>(nullPromise)
  React.useEffect(() => {
    setFetching(fetch(input))
  },dependencies)
  const result = React.useMemo(() => [
    stateFetching,
    (x) => {
      const fetching = fetch(x)
      setFetching(fetching)
      return fetching
    }
  ] as Result<a,b>,[stateFetching])
  return result
}

export default useFetch
